import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HOME_DEFAULTS } from "@/data";

const Ctx = createContext({ home: HOME_DEFAULTS });
export const useHome = () => useContext(Ctx);

// Shallow-merge saved sections over defaults (editor always saves whole sections).
const merge = (saved) => {
  const out = { ...HOME_DEFAULTS };
  Object.keys(saved || {}).forEach((k) => { if (saved[k]) out[k] = saved[k]; });
  return out;
};

// Don't render with the built-in defaults while the saved content is loading, otherwise
// the old default hero images flash before the CMS images. Defaults are only used if the
// API fails or is unusually slow.
const MAX_WAIT_MS = 5000;

export const HomeProvider = ({ children }) => {
  const [home, setHome] = useState(HOME_DEFAULTS);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let done = false;
    const finish = () => { if (!done) { done = true; setReady(true); } };
    const timer = setTimeout(finish, MAX_WAIT_MS);
    api.get("/homepage")
      .then((r) => { if (r.data && Object.keys(r.data).length) setHome(merge(r.data)); })
      .catch(() => {})
      .finally(() => { clearTimeout(timer); finish(); });
    return () => clearTimeout(timer);
  }, []);
  if (!ready) return <div style={{ minHeight: "100vh" }} aria-busy="true" />;
  return <Ctx.Provider value={{ home }}>{children}</Ctx.Provider>;
};
